import {axiosApi} from '../axios'
import { dayEnd, dayStart, yearStart, yearEnd, monthStart, monthEnd } from '../../utils/common/DateUtil'

export const getBaseInfo = function (projectId) {
	return axiosApi("get", "/project/info")({
		projectId
	})
}
export const GetAllAreas1 =  function (projectId) {
	return axiosApi("get", "/area/project/all")({
		projectId
	})
}

// 能源分析数据
export const POWER_ANALYSIS_BY_LOOP = (d, range, loopId) => {
    let start
    let end
    if (range === 'year') {
        start = yearStart(d)
        end = yearEnd(d)
    } else {
        start = monthStart(d)
        end = monthEnd(d)
    }

    return axiosApi("get", "/power/powerAnalysis/loop")({
        deviceLoopId: loopId,
        start,
        end
    })
}

